import '../css/app.css';

import 'lazysizes';

import loadComponents from 'gia/loadComponents';
import components from './components';

window.loadComponents = loadComponents;
window.components = components;
loadComponents(components);


import Cart from './vue-components/Cart.vue';
import AddToCart from './vue-components/AddToCart.vue';
import Museum from './vue-components/Museum.vue';
import MuseumAdmin from './vue-components/MuseumAdmin.vue';
import CancelBooking from './vue-components/CancelBooking.vue';
import { createApp, provide } from 'vue';
import mitt from 'mitt';

import { createPinia } from 'pinia'
import { VueReCaptcha } from 'vue-recaptcha-v3'




function initVue() {
  if (document.querySelector('#app-cart')) {
    console.log('adsf');
    const app = createApp({
      compilerOptions: {
        delimiters: ['${', '}']
      },
      components: {
        Cart
      },
      data() {
        return {}
      }
    });
    // app.use(pinia);
    app.provide('emitter', emitter);

    app.mount('#app-cart');
  }

  if (document.querySelector('#app-add-to-cart')) {
    console.log('adsf');
    const app = createApp({
      compilerOptions: {
        delimiters: ['${', '}']
      },
      components: {
        AddToCart
      },
      data() {
        return {}
      }
    });
    app.provide('emitter', emitter);

    app.mount('#app-add-to-cart');
  }
  if (document.querySelector('#app-museum')) {
    const app = createApp({
      compilerOptions: {
        delimiters: ['${', '}']
      },
      components: {
        Museum
      },
      data() {
        return {}
      }
    });
    app.use(VueReCaptcha, {siteKey: '6LcO2UQrAAAAAOdBC8f26d7662A04-v9msPGnOBd'})


    app.mount('#app-museum');
  }
  if (document.querySelector('#app-museum-admin')) {
    const app = createApp({
      compilerOptions: {
        delimiters: ['${', '}']
      },
      components: {
        MuseumAdmin
      },
      data() {
        return {}
      }
    });

    app.mount('#app-museum-admin');
  }

  if (document.querySelector('#app-cancel-booking')) {
    const app = createApp({
      compilerOptions: {
        delimiters: ['${', '}']
      },
      components: {
        CancelBooking
      },
      data() {
        return {}
      }
    });

    app.mount('#app-cancel-booking');
  }
}


const pinia = createPinia();
const emitter = mitt()

initVue();
